import type { GetTagTypeByNameResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetTagTypesByNameQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetTagTypesByNameDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseGetTagTypesByNameArgs = {
  name: string;
};

export const useGetTagTypesByName = createLazyQueryHook<
  UseGetTagTypesByNameArgs,
  GetTagTypeByNameResponseRow[],
  GetTagTypesByNameQuery
>({
  trpcQuery: (client, { name }) =>
    client.frontend.tag.tagTypeByName.query({ name }),
  mapTrpcDataToGraphQL: (data) => ({ tag_type: data }),
  graphqlDocument: GetTagTypesByNameDocument,
  graphqlVariables: ({ name }) => ({ Name: name }),
});
